import {
  pgTable,
  serial,
  timestamp,
  uuid,
  integer,
  varchar,
  boolean
} from "drizzle-orm/pg-core"
import { usersTable } from "./Users"
import { relations } from "drizzle-orm"
import { chatsMessagesTable } from "./ChatsMessages"
import { CHAT_TITLE_DEFAULT } from "$constants/chat"
import { pagesTable } from "./Pages"

export const chatsTable = pgTable("Chats", {
  id: serial().primaryKey(),
  uuid: uuid().notNull().defaultRandom().unique(),
  creationTimestamp: timestamp({ withTimezone: true }).notNull().defaultNow(),
  lastInteractionTimestamp: timestamp({ withTimezone: true }).notNull().defaultNow(),
  userId: integer().references(() => usersTable.id, { onDelete: "set null" }),
  title: varchar("title", { length: 255 }).notNull().default(CHAT_TITLE_DEFAULT),


  starterPageId: integer().references(() => pagesTable.id, { onDelete: "set null" }),
  isCachedResponse: boolean().notNull().default(false),

  telegramMessageId: varchar(),
  ip: varchar(),

  // chatSummary: text(),
  // chatSummaryTimestamp: timestamp({ withTimezone: true })
})

export const chatsRelations = relations(
  chatsTable,
  ({ one, many }) => ({
    user: one(usersTable, {
      fields: [chatsTable.userId],
      references: [usersTable.id],
    }),
    messages: many(chatsMessagesTable),
      starterPage: one(pagesTable, {
      fields: [chatsTable.starterPageId],
      references: [pagesTable.id],
    }),
  }),
)

export type ChatSchema = typeof chatsTable.$inferSelect
export type NewChatSchema = typeof chatsTable.$inferInsert
